import { merge as _merge } from 'lodash'
import es from 'core/translations/es'

export default _merge(es, {
  custom: {
    NFC_PRODUCT_NOT_ALLOWED: 'El SKU requiere una etiqueta NFC. Por favor, usa la funcionalidad de Control de Producto.'
  },
  misc: {
    last_paired_sn: 'Último SN emparejado',
    last_confirmed_ucs: 'Último UCS confirmado'
  }
})
